module.exports = __webpack_public_path__ + "static/media/lightCross.05880163.svg";